import _regeneratorRuntime from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import bippath from "bip32-path";
import { MAX_SCRIPT_BLOCK } from "./constants";
export function signMessage(_x, _x2) {
  return _signMessage.apply(this, arguments);
}

function _signMessage() {
  _signMessage = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(transport, _ref) {
    var path, messageHex, paths, message, offset, _loop, res, v, r, s;

    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            path = _ref.path, messageHex = _ref.messageHex;
            paths = bippath.fromString(path).toPathArray();
            message = Buffer.from(messageHex, "hex");
            offset = 0;
            _loop =
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _loop() {
              var maxChunkSize, chunkSize, buffer;
              return _regeneratorRuntime.wrap(function _loop$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      maxChunkSize = offset === 0 ? MAX_SCRIPT_BLOCK - 1 - paths.length * 4 - 4 : MAX_SCRIPT_BLOCK;
                      chunkSize = offset + maxChunkSize > message.length ? message.length - offset : maxChunkSize;
                      buffer = Buffer.alloc(offset === 0 ? 1 + paths.length * 4 + 2 + chunkSize : chunkSize);

                      if (offset === 0) {
                        buffer[0] = paths.length;
                        paths.forEach(function (element, index) {
                          buffer.writeUInt32BE(element, 1 + 4 * index);
                        });
                        buffer.writeUInt16BE(message.length, 1 + 4 * paths.length);
                        message.copy(buffer, 1 + 4 * paths.length + 2, offset, offset + chunkSize);
                      } else {
                        message.copy(buffer, 0, offset, offset + chunkSize);
                      }

                      _context.next = 6;
                      return transport.send(0xe0, 0x4e, 0x00, offset === 0 ? 0x01 : 0x80, buffer);

                    case 6:
                      offset += chunkSize;

                    case 7:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _loop, this);
            });

          case 5:
            if (!(offset !== message.length)) {
              _context2.next = 9;
              break;
            }

            return _context2.delegateYield(_loop(), "t0", 7);

          case 7:
            _context2.next = 5;
            break;

          case 9:
            _context2.next = 11;
            return transport.send(0xe0, 0x4e, 0x80, 0x00, Buffer.from([0x00]));

          case 11:
            res = _context2.sent;
            v = res[0] - 0x30;
            r = res.slice(4, 4 + res[3]);

            if (r[0] === 0) {
              r = r.slice(1);
            }

            r = r.toString("hex");
            offset = 4 + res[3] + 2;
            s = res.slice(offset, offset + res[offset - 1]);

            if (s[0] === 0) {
              s = s.slice(1);
            }

            s = s.toString("hex");
            return _context2.abrupt("return", {
              v: v,
              r: r,
              s: s
            });

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, this);
  }));
  return _signMessage.apply(this, arguments);
}